module.exports = __webpack_public_path__ + "img/no_graph_data_reports.dec94db2.svg";